export default process.env.NODE_ENV != "production"
  ? {
      node_api_endpoint:
        "http://localhost:4005",
      mock_api_endpoint: "http://192.168.0.196:5001",
    }
  : {
      node_api_endpoint:
        "https://sandboxportalapi.escrowstack.io",
      mock_api_endpoint: "http://192.168.0.196:5001",
    };
